/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import RevokeAccessForm from './RevokeAccessForm/RevokeAccessForm';
import RevokeAccessSuccess from './RevokeAccessSuccess/RevokeAccessSuccess';
import RevokeAccessError from './RevokeAccessError/RevokeAccessError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  currentAccountDetails: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RevokeAccess extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;
    const user: Object = this.props.formData;
    const fields: Array<Object> = [
      {
        name: 'removeReason',
        label: t('general:users.reasons.why_revoke_access'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_revoking_access'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: '1',
                label: t('general:reasons.options.change_in_role'),
              },
              {
                id: '2',
                label: t('general:reasons.options.access_no_longer_required'),
              },
              {
                id: '3',
                label: t('general:reasons.options.user_has_left'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().removeReason;
        actionDrawerStore.removeUserAccess(currentAccountDetails.id, {
          user_ids: user.id,
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'revokeAccessFromUser',
      }
    );
  };

  render(): React.Node {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;

    const user: Object = this.props.formData;

    const title: string = t('general:actions.revoke_trading_account_from_user');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RevokeAccessError />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RevokeAccessSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RevokeAccessForm user={user} account={currentAccountDetails} form={this.createForm()} />
      </div>
    );
  }
}
